import { Component, OnInit, Input } from '@angular/core';
import { EmailReminderTypeService } from '../../../../services/email-reminder-type.service';
import { EmailTemplate } from '../../../../dto/templates/email-template';
import { PaymentEmailReminderType } from '../../../../dto/payment-email-reminder-type';
import { InvoiceType } from '../../../../dto/invoice-type';
import { ReminderType } from '../../../../dto/reminder-type';

@Component({
  selector: 'app-email-reminder-types',
  templateUrl: './email-reminder-types.component.html',
  styleUrls: ['./email-reminder-types.component.css']
})
export class EmailReminderTypesComponent implements OnInit {
  
  @Input() emailTemplates: EmailTemplate[];
  @Input() invoiceType: InvoiceType;
  @Input() reminderType: ReminderType;
  @Input() caption: string;

  reminderTypes: PaymentEmailReminderType[];
  
  constructor(
    private reminderTypeService: EmailReminderTypeService,
  ) { }

  ngOnInit() {
    this.reminderTypeService.getReminderTypes(this.invoiceType).subscribe(result => {
      this.reminderTypes = result.data;
    });
  }
  
  addReminderType() {
    const item = {} as PaymentEmailReminderType;
    this.reminderTypes.push(item);
  }
}
